import type {
  CreationParams,
  CreationResponse,
  EstimateGasParams,
  EstimateGasResponse,
  GrabListParams,
  grabListResponse,
  GrabParams,
  GrabResponse,
  LuckyboxSupportChainResponse,
  PresignParams,
  PresignResponse,
} from '../sdk/types';
import { AbstractApi } from './Api';

interface MyAxiosResponseData<T = any> {
  code: number;
  data: T;
  message?: string;
}

export class LuckyBoxApi extends AbstractApi {
  getLuckyboxGrabList(params: GrabListParams) {
    return this.request<MyAxiosResponseData<grabListResponse>>({
      url: '/api/v1/luckybox/coin-packet/grab',
      method: 'GET',
      params,
    });
  }
  getLuckyboxSupportChain() {
    return this.request<MyAxiosResponseData<LuckyboxSupportChainResponse[]>>({
      url: '/api/v1/luckybox/support/chain',
      method: 'GET',
    });
  }
  getLuckyBoxEstimateGas(body: EstimateGasParams) {
    return this.request<MyAxiosResponseData<EstimateGasResponse>>({
      url: '/api/v1/luckybox/gas/estimate',
      method: 'POST',
      body,
    });
  }
  getLuckyBoxPresign(body: PresignParams) {
    return this.request<MyAxiosResponseData<PresignResponse>>({
      url: '/api/v1/luckybox/creation/presign',
      method: 'POST',
      body,
    });
  }
  creationLuckyBox(body: CreationParams) {
    return this.request<MyAxiosResponseData<CreationResponse>>({
      url: '/api/v1/luckybox/creation',
      method: 'POST',
      body,
    });
  }
  grabLuckyBoxCoinPacket(body: GrabParams) {
    return this.request<MyAxiosResponseData<GrabResponse>>({
      url: '/api/v1/luckybox/coin-packet/grab',
      method: 'POST',
      body,
    });
  }
}
